import { useTranslation } from 'react-i18next'

import { CheckIcon } from '@/components/icons/Check'

export const PhonePopupSuccess = () => {
  const { t } = useTranslation()

  return (
    <div className="animate-fade-in flex flex-col items-center gap-4 px-4 py-8">
      <CheckIcon />
      <p className="mt-4 text-center">{t('sms_reminder.confirmation')}</p>
    </div>
  )
}
